export default "__VITE_ASSET__py3mSj1u__"